<template>
  <ya-site-resource-list resource="area" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteAreaList',
  components: { YaSiteResourceList },
}
</script>
